import { render, staticRenderFns } from "./trafficDetail.vue?vue&type=template&id=0ee14443&scoped=true&"
import script from "./trafficDetail.vue?vue&type=script&lang=js&"
export * from "./trafficDetail.vue?vue&type=script&lang=js&"
import style0 from "./trafficDetail.vue?vue&type=style&index=0&id=0ee14443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee14443",
  null
  
)

export default component.exports